var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"error"},on:{"enter":_vm.updateHeight}},[(_vm.show)?_c('div',{staticClass:"FieldError",style:(_vm.compStyle)},[_c('div',{ref:"$wrapper",staticClass:"wrapper"},[_c('p',{staticClass:"message"},[_vm._t("default")],2)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }